var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4318ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.327 4.127a1.8 1.8 0 0 1 2.546 2.546l-2.7 2.7a1.8 1.8 0 0 1-2.546 0 .9.9 0 1 0-1.273 1.272 3.6 3.6 0 0 0 5.091 0l2.7-2.7a3.6 3.6 0 1 0-5.09-5.09l-1.35 1.35a.9.9 0 1 0 1.272 1.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.827 8.627a1.8 1.8 0 0 1 2.546 0 .9.9 0 0 0 1.272-1.273 3.6 3.6 0 0 0-5.09 0l-2.7 2.7a3.6 3.6 0 0 0 5.09 5.091l1.35-1.35a.9.9 0 0 0-1.272-1.272l-1.35 1.35a1.8 1.8 0 0 1-2.546-2.546z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.cc79d459901c0bff86433f471c4856bd.svg";
export { ForwardRef as ReactComponent };